var module = angular.module('octopusApp.infrastructure');

module.controller('PromptDialogController', function ($scope, busy, options, $uibModalInstance) {
  var isWorking = $scope.isWorking = busy.create();
  $scope.options = options;

  $scope.close = function() {
    $uibModalInstance.close();
  };

  $scope.execute = function () {
    $scope.options.execute({
      answer: $scope.options.answer,
      busy: isWorking,
      dismiss: function () {
        $uibModalInstance.close(true);
      }
    });
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/controllers/prompt_dialog_controller.js
// module id = 2655355696295565
// module chunks = 1